// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-container{
    padding: 20px 50px;
}
.panel-container .MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.css-1h9z7r5-MuiButtonBase-root-MuiTab-root{
    background-color: white;

}
.panel-container .MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.css-1h9z7r5-MuiButtonBase-root-MuiTab-root{
    color:#fff !important;
    background-color: #629ad2 !important;
    font-weight: bold !important;
}
.panel-container .css-35zqo5-MuiTabs-root{
    overflow: visible !important;
}

.panel-container .MuiTabs-root.MuiTabs-vertical.css-35zqo5-MuiTabs-root{
    border-right: 0px;
}

.panel-container #vertical-tab-0,
.panel-container #vertical-tab-1,
.panel-container #vertical-tab-2,
.panel-container #vertical-tab-3{
    margin: 10px 0px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
}

.panel-container #vertical-tab-0::before,
.panel-container #vertical-tab-1::before,
.panel-container #vertical-tab-2::before,
.panel-container #vertical-tab-3::before
{
    font-family: "Font Awesome 5 Free";
    display: inline-block;
    margin-bottom: 15px;
    vertical-align: middle;
    font-weight: 900;
    font-size: 24px;
}

.panel-container #vertical-tab-0::before{
    content: "\\f27a";
}

.panel-container #vertical-tab-1::before{
    content: "\\f017";
}
.panel-container #vertical-tab-2::before{
    content: "\\f53d";
}

.panel-container #vertical-tab-3::before{
    content: "\\f233";
}`, "",{"version":3,"sources":["webpack://./src/components/controlPanel/panel.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,uBAAuB;;AAE3B;AACA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;IAII,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;;;;;IAKI,kCAAkC;IAClC,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".panel-container{\r\n    padding: 20px 50px;\r\n}\r\n.panel-container .MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.css-1h9z7r5-MuiButtonBase-root-MuiTab-root{\r\n    background-color: white;\r\n\r\n}\r\n.panel-container .MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.css-1h9z7r5-MuiButtonBase-root-MuiTab-root{\r\n    color:#fff !important;\r\n    background-color: #629ad2 !important;\r\n    font-weight: bold !important;\r\n}\r\n.panel-container .css-35zqo5-MuiTabs-root{\r\n    overflow: visible !important;\r\n}\r\n\r\n.panel-container .MuiTabs-root.MuiTabs-vertical.css-35zqo5-MuiTabs-root{\r\n    border-right: 0px;\r\n}\r\n\r\n.panel-container #vertical-tab-0,\r\n.panel-container #vertical-tab-1,\r\n.panel-container #vertical-tab-2,\r\n.panel-container #vertical-tab-3{\r\n    margin: 10px 0px;\r\n    border-radius: 8px;\r\n    -webkit-border-radius: 8px;\r\n    -moz-border-radius: 8px;\r\n    -ms-border-radius: 8px;\r\n    -o-border-radius: 8px;\r\n}\r\n\r\n.panel-container #vertical-tab-0::before,\r\n.panel-container #vertical-tab-1::before,\r\n.panel-container #vertical-tab-2::before,\r\n.panel-container #vertical-tab-3::before\r\n{\r\n    font-family: \"Font Awesome 5 Free\";\r\n    display: inline-block;\r\n    margin-bottom: 15px;\r\n    vertical-align: middle;\r\n    font-weight: 900;\r\n    font-size: 24px;\r\n}\r\n\r\n.panel-container #vertical-tab-0::before{\r\n    content: \"\\f27a\";\r\n}\r\n\r\n.panel-container #vertical-tab-1::before{\r\n    content: \"\\f017\";\r\n}\r\n.panel-container #vertical-tab-2::before{\r\n    content: \"\\f53d\";\r\n}\r\n\r\n.panel-container #vertical-tab-3::before{\r\n    content: \"\\f233\";\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
